
require('./customFinalButton.scss')

// @ verdors
import React from 'react'

// @ components
import { OKButton } from 'components/commons/OKButton/OKButton';

export default function CustomFinalButton(props) {
    return (
        <div className="button-wrapper">
            <OKButton {...props}/>
        </div>
    )
}